
import wx from 'weixin-js-sdk'
import html2canvas from 'html2canvas'
import { funcUrlDel, nowInDateBetwen } from '@/libs/utils'
import config from '@/config/index'
import {
getPartyVoteDetail,
addVotePartyVotelog,
addCount
} from '@/api/youzheng'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Qrcode from 'vux/src/components/qrcode/index.vue'
import InlineXNumber from 'vux/src/components/inline-x-number/index.vue'

import { getConfig } from '@/api/wx.js'
import { operateCreditlist } from '@/api/user'
export default {
directives: {
TransferDom
},
components: {
Swiper,
SwiperItem,
XDialog,
Qrcode,
InlineXNumber
},
props: ['partyObj'],
data () {
return {
baseUrl: this.$config.baseUrl,
partyid: this.$route.params.artid,
voteid: this.$route.params.voteid,
openid: this.$storage.get('openid'),
obj: {},
imglist: [],
showDialog: false,
showDialogShare: false,
downImgUrl: '',
qrcodeUrl: '',
votenum: 1,
voteTotal: 0, // 可投票数量
status: 0, // 0还未开始，1正在进行，-1结束
showbtn: true,
video: ''
}
},
computed: {
userid () {
return this.$store.state.user.userid
},
accountid () {
return this.$store.state.user.accountid
}
},
created () {

this.status = nowInDateBetwen(
this.partyObj.votestartdate,
this.partyObj.voteenddate
)
this.getDetail()

},
methods: {
getDetail () {
getPartyVoteDetail({
id: this.voteid,
openid: this.openid
}).then(data => {
this.obj = data.obj
this.video = data.obj.mediaList[0].VJMSURL





})
},
showShare () {
this.share()
},

shareImg () {
html2canvas(this.$refs.imageWrapper, {
width: this.$refs.imageWrapper.clientWidth, // dom 原始宽度
height: this.$refs.imageWrapper.clientHeight,
scrollY: 0,
scrollX: 0,
useCORS: true
}).then(canvas => {
let dataURL = canvas.toDataURL('image/jpg')
this.downImgUrl = dataURL
})
},

share () {
this.qrcodeUrl =
'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' +
config.appid +
'&redirect_uri=' +
funcUrlDel('code') +
'/&response_type=code&scope=snsapi_base&state=200&connect_redirect=1#wechat_redirect'
this.showDialogShare = true
setTimeout(() => {
this.shareImg()
}, 500)
},
showDialogFun () {
this.showDialog = true
}














































































}
}
